import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { User } from '../../models/admin-models/user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/users/' + id).toPromise();
    }

    getTotal(filter: Filter) {
        return this.httpClient.post('api/users/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.total;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/users/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    boxView(filter: Filter) {
        return this.httpClient.post('api/users/boxview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createUser(user: User) {
        return this.httpClient.post('api/users/create', user.data).toPromise();
    }

    editUser(user: User) {
        return this.httpClient.post('api/users/edit', user.data).toPromise();
    }

    deleteUser(ids: Array<Number>) {
        return this.httpClient.post('api/users/delete', ids).toPromise();
    }

    getUser() {
        return this.httpClient.get('api/users/getuser').toPromise();
    }

    getRole() {
        return this.httpClient.get('api/users/getroles').toPromise();
    }

    userSignature(signature: { UserID: Number, Signature: any }) {
        return this.httpClient.post('api/users/setsignature', signature).toPromise();
    }

    setNewPassword(id: Number, password: String) {
        return this.httpClient.post('api/users/setpassword', { UserID: id, NewPassword: password }).toPromise();
    }

}